module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('button', {
    staticClass: "button is-facebook is-outlined is-fullwidth",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.signIn()
      }
    }
  }, [_vm._v("\n  Preparando   "), _c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v("...\n")]) : _c('button', {
    staticClass: "button is-facebook is-outlined is-fullwidth",
    attrs: {
      "disabled": _vm.login
    },
    on: {
      "click": function($event) {
        return _vm.signIn()
      }
    }
  }, [_vm._v("\n  Iniciar Sesión con   "), _c('i', {
    staticClass: "fa fa-facebook"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c08194c2","hasScoped":false}!./src/components/fb-button/template.html
// module id = 426
// module chunks = 1